var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Ccon"},[_c('div',{attrs:{"id":"container"}}),_c('div',{staticClass:"btn",on:{"click":_vm.getLine}},[_vm._v("移动")])])
}
var staticRenderFns = []

export { render, staticRenderFns }